import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=26faff0c&scoped=true&"
import script from "./Informes.vue?vue&type=script&lang=js&"
export * from "./Informes.vue?vue&type=script&lang=js&"
import style0 from "./Informes.scss?vue&type=style&index=0&id=26faff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26faff0c",
  null
  
)

export default component.exports